const getIconPathIfExists = (path: string): Promise<string | null> => {
  return new Promise((resolve) => {
    const img = new Image();

    img.onload = () => {
      resolve(path);
    };

    img.onerror = () => {
      resolve(null);
    };

    img.src = path;
  });
};

export default getIconPathIfExists;
